import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import AuthContext from '../authContext';

import { getIdHashFromCookie, getIdHashFromUrl, useValidateIdHash } from '../../../utils/idHashUtils';

import { CLIENT_ID_LOGIN, CLIENT_STATE_LOGIN } from '../../../hooks/constants';

export type { ActionsModel, InitialStateModel } from './types';

const baseUrl = process.env.REACT_APP_BACKEND_URL;

export const bMIdentityLogin = () => {
  const redirection = window.location.pathname.startsWith('/sonderangebot')
    ? window.location.pathname + window.location.search
    : window.location.pathname;
  localStorage.setItem('login_redirection', redirection);
  window.location.href=`https://id.${baseUrl?.includes('stage')?'stage.':''}bluemovie.com/bm/ident/auth?client_id=${CLIENT_ID_LOGIN}&redirect_uri=https://${baseUrl?.includes('stage')?'stage.':''}bluemovie.com/loginresponse&response_type=code&state=${CLIENT_STATE_LOGIN}&country=DE#/`;
}

// Custom hook for login redirection - use this in components
export const useLoginRedirection = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { setOverrideData } = authContext;
  const { mutateAsync: validateIdHash } = useValidateIdHash();

  return async () => {
    const cookieIdHash = getIdHashFromCookie();
    const urlIdHash = getIdHashFromUrl();
    const idHash = cookieIdHash || urlIdHash;

    // If no id_hash exists, proceed with normal login redirection
    if (!idHash) {
      return bMIdentityLogin();
    }

    // If id_hash exists, validate it
    try {
      const validation = await validateIdHash(idHash);

      // If validation returns 403, proceed with normal login redirection
      if (validation.status === 403) {
        return bMIdentityLogin();
      }

      // If validation is successful (not 403), continue with normal flow
      if (validation.status === 'success') {
        console.log('Validation successful, proceeding with login flow');
        // Store redirection path for after login
        localStorage.setItem('login_redirection', window.location.pathname);
        setOverrideData(validation);
        // Navigate to login response page
        navigate('/loginresponse');
      }
    } catch (error) {
      // Log the error for debugging
      console.error('Error validating id_hash:', error);
      // Fallback: proceed with normal login flow when API fails
      return bMIdentityLogin();
    }
  };
};
